import { render } from "./loader-item.vue?vue&type=template&id=77d4b1ac&lang=pug"
import script from "./loader-item.vue?vue&type=script&lang=js"
export * from "./loader-item.vue?vue&type=script&lang=js"

import "./loader-item.vue?vue&type=style&index=0&id=77d4b1ac&lang=sass"

import exportComponent from "/builds/WebServers/festival/leaderboards/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__